import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as G2 from '@antv/g2';
import { Select, Store } from '@ngxs/store';
import { BehaviorSubject, Observable, Unsubscribable, firstValueFrom } from 'rxjs';
import { ModalBuilderService } from '../../services/modal-builder.service';
import { FormIframeComponent } from '../../components/form-iframe/form-iframe.component';
import { RDMClientService } from '../../services/rdm-client.service';
import { BaseSharedState } from '../../store/base.state';
import { RefType } from '../../interfaces/rdm-client.interface';
import { RiskManagementTableService } from '../../services/risk-management.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { CombineSubscriptions, DestroySubscribers } from 'base-shared';

@DestroySubscribers({
  destroyFunc: 'ngAfterViewInit',
})
@Component({
  selector: 'app-base-preview',
  templateUrl: './base-preview.component.html',
  styleUrls: ['./base-preview.component.less']
})
export class BasePreviewComponent implements OnInit, AfterViewInit {

  /*
   Within the @CombineSubscriptions Decorator, you can choose any custom name that you prefer.
   Without the @CombineSubscriptions Decorator, the name by default is 'subscriber'.
  */
  @CombineSubscriptions()
  private subscriber: Unsubscribable;
  public pageSize:number = 10;
  public pageIndex:number = 1;

  @Input() value: any;
  rdmData: any = {};
  rdmDataList: any[] = [];
  listofLongRoutedContainers: any[] = [];
  //@Select(BaseSharedState.getRdmData) rdmData$: Observable<any>;
  public rdmData$ = new BehaviorSubject<any>([]);
  data: any;
  chart: any;
  isExternalSourcePopupVisible = false;
  markers: any[] = [];
  constructor(private drawerRef: NzDrawerRef<any>,
    private rdmService: RDMClientService,
    private modalService: ModalBuilderService,
    private router: Router,
    private clientService: RiskManagementTableService,
    private store: Store, ) {
  }

  listOfParentData: any[] = [];
  listOfChildrenData: any[] = [];

  async ngOnInit() {
     await this.initSchemaAndIndicators();
    this.subscriber = this.rdmData$.subscribe(res => {
      this.rdmDataList = res.get('kc-profile-treatment-recommended-actions');
      this.rdmData = res
    });
    this.chart = new G2.Chart({
      container: 'risktScore',
      width: 500,
      height: 363
    });
    this.chart.source(this.value.previewData.gDtata);
    this.chart.interval()
      .position('x*y')
      .color('x')
      // .label('value', { offset: 10 });
    this.chart.render();
    this.loadLongRoutedContainers(this.value.previewData.tgData.referanceId);
    this.setSource();
  }

  async initSchemaAndIndicators() {
      try {
        const [rdmData] = await Promise.all([
          firstValueFrom(this.store.select(BaseSharedState.getRdmData)),
  
        ]);
        await this.rdmData$.next(rdmData);
      } catch (error) {
  
      }
    }

  getRdmDataByRefTypeAndCode(refTypeCode: string, code: string): string {
    if (code !== null) {
      if (this.rdmService.getRefValues(refTypeCode)) {
        const [item] = this.rdmService.getRefValues(refTypeCode).filter((item: any) => item.code == code);
        if (item) return item.label;
        else return 'NA';
      } else {
        return code
      }
    } else {
      return ""
    }

  }

  getRdmDesc(label: string): string {
    if (this.rdmDataList) {
      const [item] = this.rdmDataList.filter(item => item.code == label);
      if (item) return item.label;
      else return 'No description found';
    } else {
      return 'No description found';
    }
  }

  viewDeclaration() {
    let viewDeclarationUrl = '';
    let formModalTitle = '';

    switch (this.value.screen) {
      case 'declaration':
        if (this.value?.type?.length >= 0) {
          viewDeclarationUrl = window.location.origin + window.location.pathname + '/#/app/cargoes-transfer/view-form/' + this.value.previewData.tgData.referanceId + '?isDialog=true';
          formModalTitle = 'View Cargoes Transfer';
        } else {
          viewDeclarationUrl = window.location.origin + window.location.pathname + '/#/app/ics-declaration/view-form/' + this.value.previewData.tgData.referanceId + '?isDialog=true';
          formModalTitle = 'View Declaration';
        }
        break;
      case 'passenger-declaration':
        viewDeclarationUrl = window.location.origin + window.location.pathname + '/#/app/ics-declaration/view-passenger/' + this.value.previewData.declarationId + '?isDialog=true';
        formModalTitle = 'View Passenger Declaration';
        break;
      case 'manifest':
        viewDeclarationUrl = window.location.origin + window.location.pathname + '/#/app/ums-manifest/view-form/' + this.value.previewData.tgData.referanceId + '?isDialog=true';
        formModalTitle = 'View Manifest';
        break;
      default:
        console.log("No such day exists!");
        break;
    }

    this.modalService.openModalForm(FormIframeComponent, {
      iFrameLink: viewDeclarationUrl
    }, formModalTitle, 1100);
  }

  /*
   This method must be declared, even if it's empty.
   Otherwise, the Decorator would throw an Error.
  */
  ngAfterViewInit() {
    console.log('for unsubscribing');
  }

  splitRecomndedAction(value: any): string[] {
    return _.split(value, ',')
  }

  viewProfile(id: number) {
    this.drawerRef.close();
    this.router.navigateByUrl('/app/intelligencemgmt/profile-mgmt/view-profile/' + id);
  }

  loadLongRoutedContainers(manifestId: number) {
    this.clientService.longRoutedContainers(manifestId).subscribe((res: any) => {
      console.log(res);
      if (res.statusCode == 200) {
        this.listofLongRoutedContainers = res.content;
      }
    });
  }

  setSource() {
    this.value.previewData.tData.forEach((element: any) => {
      this.clientService.getRiskInfoForProfileCode(element.profileCode).subscribe((res: any) => {
        if (res.content) {
          element.source = res.content.source;
          element.riskInformationId = res.content.riskInformationId;
        }
      })
    });
  }

  viewExternalSourceRiskInforPopup(data: any) {
    this.markers = [];
    this.clientService.searchExternalNews(data.source, 0, 200, "receivedDate,desc").subscribe((response: any) => {
      if (response.content.content) {
        response.content.content.forEach((element: any) => {
          const newsObj = JSON.parse(element.newsStr);
          if (newsObj.latitude) {
            const marker: any = {
              position: { lat: +newsObj.latitude, lng: +newsObj.longitude },
              title: newsObj.title, clickable: true, news: newsObj, icon: undefined, highlight: false
            }
            if (newsObj.category?.pictogram?.url)
              marker.icon = "https://iris.wcoomd.org" + newsObj.category?.pictogram?.url
            if (element.riskInformationId == data.riskInformationId)
              marker.highlight = true
            this.markers.push(marker);
          }
        });
        this.isExternalSourcePopupVisible = true;
      }
    });
  }


  closeExternalSourceRiskInfoDialogue() {
    this.isExternalSourcePopupVisible = false;
  }
}
